<template>
  <BenefitsCollapsibleSection :title="t('benefitsCenter-terms-title')" :default-open="false">
    <div class="benefits-terms-section">
      <KvButton class="benefits-terms-edit-button" type="button" variant="outlined" @click="openPanel">
        <Icon icon-class="ui-settings-02" size="5" color="#1f2a37" />
        {{ t("benefitsCenter-terms-settings") }}
      </KvButton>
    </div>

    <BenefitsSidePanel v-model="panelOpen" :title="t('benefitsCenter-terms-panelTitle')"
      :close-label="t('benefitsCenter-terms-close')" @close="resetDraft">
      <div class="benefits-terms-field">
        <BenefitsRichText v-model="draft" :placeholder="t('benefitsCenter-terms-bodyPlaceholder')" height="320px" />
      </div>

      <template #footer>
        <KvButton class="benefits-terms-close-button" type="button" variant="outlined" @click="closePanel">
          {{ t("benefitsCenter-terms-close") }}
        </KvButton>

        <KvButton class="benefits-terms-save-button" type="button" @click="saveTerms">
          <Icon icon-class="ui-check" size="4" color="#ffffff" />
          {{ t("benefitsCenter-terms-saveChanges") }}
        </KvButton>
      </template>
    </BenefitsSidePanel>
  </BenefitsCollapsibleSection>
</template>

<script>
import Icon from "../../../components/icon/icon";
import KvButton from "../../../components/form/kv-button.vue";
import BenefitsCollapsibleSection from "../../shared/benefits-collapsible-section.vue";
import BenefitsSidePanel from "../../shared/benefits-side-panel.vue";
import BenefitsRichText from "../../shared/benefits-rich-text.vue";

export default {
  name: "BenefitsTermsSection",
  components: {
    Icon,
    KvButton,
    BenefitsCollapsibleSection,
    BenefitsSidePanel,
    BenefitsRichText,
  },
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      panelOpen: false,
      draft: this.normalizeValue(this.value),
    };
  },
  watch: {
    value: {
      deep: true,
      handler(value) {
        if (!this.panelOpen) {
          this.draft = this.normalizeValue(value);
        }
      },
    },
  },
  methods: {
    t(term, replaces) {
      return this.$root.t(term, replaces);
    },
    normalizeValue(value) {
      return typeof value === "string" ? value : "";
    },
    openPanel() {
      this.draft = this.normalizeValue(this.value);
      this.panelOpen = true;
    },
    closePanel() {
      this.panelOpen = false;
      this.resetDraft();
    },
    resetDraft() {
      this.draft = this.normalizeValue(this.value);
    },
    saveTerms() {
      try {
        this.$emit("input", String(this.draft || "").trim());
        this.panelOpen = false;
      } catch (error) {
        this.$store.dispatch("notification/error", {
          text: this.t("benefitsCenter-terms-error"),
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.benefits-terms-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: none;
  min-width: 0;
  width: 50%;
}

.benefits-terms-edit-button {
  align-items: center;
  appearance: none;
  background: #fcfcfd;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  color: #1f2a37;
  cursor: pointer;
  display: inline-flex;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 400;
  gap: 8px;
  height: 44px;
  justify-content: center;
  line-height: 1.2;
  padding: 12px;
  transition: background 0.18s ease, border-color 0.18s ease;
  min-width: 156px;
  max-width: 100%;
  width: 156px;

  &:hover,
  &:focus {
    background: #e5e7eb;
    border-color: #d2d6db;
    outline: none;
  }
}

.benefits-terms-edit-button::v-deep .kv-button-content,
.benefits-terms-close-button::v-deep .kv-button-content,
.benefits-terms-save-button::v-deep .kv-button-content {
  gap: inherit;
  line-height: inherit;
}

.benefits-terms-field {
  display: flex;
  flex-direction: column;
  width: 100%;

  ::v-deep .kv-editor {
    width: 100%;
  }
}

.benefits-terms-close-button,
.benefits-terms-save-button {
  align-items: center;
  appearance: none;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 400;
  gap: 6px;
  height: 36px;
  justify-content: center;
  line-height: 1.2;
  padding: 8px 12px;
}

.benefits-terms-close-button {
  background: #fcfcfd;
  border: 1px solid #e5e7eb;
  color: #1f2a37;
}

.benefits-terms-save-button {
  background: #4caf5d;
  border: 1px solid #4caf5d;
  color: #ffffff;
  margin-left: auto;
}

@media (max-width: 1100px) {
  .benefits-terms-section {
    width: 100%;
  }
}

@media (max-width: 700px) {
  .benefits-terms-edit-button {
    width: 100%;
  }
}
</style>
